/* @ngInject */
export default function routes($stateProvider) {
  $stateProvider
    .state('public.case.authorizationForm', {
      url: '/:id/authorizationForm',
      template: '<public-authorization-form case="$resolve.case"></public-authorization-form>',
      resolve: {
        /* @ngInject */
        case: ($http, $stateParams, $state) => {
          return $http
            .get(`/public/case/${$stateParams.id}`, {
              params: { caseResponse: true },
              ignoreAuthModule: true,
            })
            .then(({ data }) => data)
            .catch(() => $state.go('four-o-three'));
        },
      },
    });
}



// WEBPACK FOOTER //
// ./client/app/public/case/authorization-form/authorization-form.routes.js